<ng-container *ngIf="task">
    <div *ngIf="!isJobProcess && !task.isReplaceLandUseIdsProcess" class="process-content">
        <app-task-process-detail-view *ngIf="task" [task]="task" [zoningCode]="zoningCode"
            [isZoningCodeLoading]="isZoningCodeLoading">
        </app-task-process-detail-view>
    </div>
    <div *ngIf="isJobProcess && !task.isReplaceLandUseIdsProcess" class="process-content">
        <app-job-process-details-view [task]="task" [isStep]="false"></app-job-process-details-view>
    </div>

    <div *ngIf="task.isReplaceLandUseIdsProcess" class="process-content">
        <app-replace-land-use-ids-details-view [process]="task"></app-replace-land-use-ids-details-view>
    </div>
</ng-container>

<div class="no-task-header" *ngIf="!task && !showSpinner">
    <h2>Tasks are not found</h2>
</div>


<app-spinner [showOverlay]="true" *ngIf="showSpinner"></app-spinner>